import React ,{ useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { setLeftPage } from '../../../actions/ui'
import { setOpenLogin, setLeftBoothList, setBookmardUpdated, setOpenBoothList, setCuratedId } from '../../../actions/ui'
import Exhibitors from "./Exhibitors"
import { setActive3dObject, setExhibitorList } from '../../../actions/main';
import { setSearchOptions } from '../../../actions/searchbox'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { getTokenCookie, getTokenPlanner, getUrlToken } from '../../../utils/Common'
import Fade from '@mui/material/Fade';
import SearchBox from '../SearchBox.js';
import axiosInstance from '../../../utils/axiosInstance.js'
import {
  useLocation
} from "react-router-dom";
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import { highlightObject, checkIfSelectable, deselectHighlightObject } from '../../../utils/CanvasTool';
import { ESHOW_URL } from '../../../config.js';
import qs, { parse } from 'qs';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
var highlightedBooths = [];

function Index(props) {
    const [allBoothList, setAllBoothList] = useState([]);
    const [loadingFlag, setLoadingFlag] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);

    let query = useQuery();

    const curatedGroup = props.ui.curatedId; // Duc

    const getBoothByKey = (object_key)=>{
        var objects = props.main.mainCanvas.getObjects('group')
        for(var i = 0; i < objects.length; i++){
          if(checkIfSelectable(objects[i])){
            if(objects[i].class=='booth' || objects[i].class=='symbol'){
              if(objects[i].KEY_ID == object_key){
                return objects[i]
              }
            }
          }
        }
        return null
      }

    const fetchCuratedList = ()=>{
      setLoadingFlag(true);
      setLoaded(false);

      var boothList = props.main.mainCanvas.getObjects();
      var active_booth_file = props.main.active_booth_file;
      highlightedBooths = [];

      var url = `${ESHOW_URL()}?method=getCuratedGroups&token=${getTokenCookie()}&map_key=${active_booth_file.KEY_ID}`;

      axiosInstance.get(url).then(res=>{
          const result = res.data;
          if(result.SUCCESS){  
              //props.setSearchOptions(result.SEARCH) ;
              //props.setExhibitorList(result);

              if(result.CURATED_GROUPS){
                var activeBoothList = [];
                for(var i = 0; i< result.CURATED_GROUPS.length; i++){
                  var item = result.CURATED_GROUPS[i];
                  if(item['KEY_ID'] == curatedGroup){
                    for(var j=0; j<item['POI'].length; j++){
                      var boothInfo = item['POI'][j];

                      // get booth item
                      var booth = getBoothByKey(boothInfo['OBJECT_KEY']);
                      if (booth == null) continue;

                      highlightObject(booth, props.main, true);
                      highlightedBooths.push(booth);

                      activeBoothList.push(
                        {
                          booth: boothInfo['BOOTH_NO']?boothInfo['BOOTH_NO']:"",
                          BOOTHS: boothInfo['BOOTH_NO']?boothInfo['BOOTH_NO']:"",
                          name: boothInfo['BOOTH_NO']?boothInfo['BOOTH_NO']:"",
                          priced:false,
                          id:booth['id'],                          
                          // description:item['DESCRIPTION']?item['DESCRIPTION']:"",
                          EXHIBITOR_KEY:boothInfo['EXHIBITOR_KEY']?boothInfo['EXHIBITOR_KEY']:"",
                          company:boothInfo['COMPANY_NAME']?boothInfo['COMPANY_NAME']:"",
                          MAP_NAME:active_booth_file['TITLE'],
                          MAP_KEY:active_booth_file?.KEY_ID?active_booth_file?.KEY_ID:"",
                          title: boothInfo['TITLE']?boothInfo['TITLE']:"",
                          img_url:booth['img_url'],
                          class: booth['class'],
                          DATE: boothInfo['DATE']?boothInfo['DATE']:"",
                          start_time: boothInfo['START']?boothInfo['START']:"",
                          end_time: boothInfo['END']?boothInfo['END']:"",
                          timezone: boothInfo['TIMEZONE']?boothInfo['TIMEZONE']:"",
                          obj:booth
                        }
                      );

                    }
                  }
                }              
                props.setLeftBoothList(activeBoothList);

              }
              setLoadingFlag(false);
              setLoaded(true);
          }
          else{
            setLoadingFlag(false);
            setLoaded(true);
          }
      }).catch(error => {
        setLoadingFlag(false);
        setLoaded(true);
      })  
    }

    const getAllBoothList = ()=>{
      setLoadingFlag(true)
      setLoaded(false)
      var active_booth_file = props.main.active_booth_file
      var token = getTokenCookie();   
      var map_key;   
      if(props.main.authInfo?.role != 'admin') {
        try{     
            var _token = getTokenPlanner();
            if(_token){
              token = _token
            }
        }
        catch(e){
          console.log("token parse", e)
        }
      }
      else{
      }
      // Scope list to the loaded map
      map_key = active_booth_file?.KEY_ID
      if(query.get("map")){
        map_key = query.get("map");
      }
      var url = `${ESHOW_URL()}?method=getExhibitorList&token=${token}${map_key?('&map_key='+map_key):''}`
      const options = {
          headers: {"content-type": 'application/x-www-form-urlencoded'}
      }
      axiosInstance.get(url).then(res=>{
          const result = res.data;
          if(result.SUCCESS){  
              props.setSearchOptions(result.SEARCH) 
              props.setExhibitorList(result)
              if(result.EXHIBITORS){
                var boothList = [];
                for(var i = 0; i< result.EXHIBITORS.length; i++){
                  var item = result.EXHIBITORS[i]
                  if(!item?.SETUP?.LIST_PENDING_EXHIBITORS && item.STATUS == 2)
                    continue;
                  boothList.push(
                    {
                      booth: item['BOOTHS']?item['BOOTHS']:"",
                      BOOTHS: item['BOOTHS']?item['BOOTHS']:"",
                      name:item['BOOTHS']?item['BOOTHS']:"",
                      priced:false,
                      id:"",
                      EXHIBITOR_KEY:item['EXHIBITOR_KEY']?item['EXHIBITOR_KEY']:"",
                      company:item['COMPANY_NAME']?item['COMPANY_NAME']:"",
                      bookmark:item['BOOKMARKED']?item['BOOKMARKED']:"",
                      MAP_NAME:item['MAP_NAME']?item['MAP_NAME']:"",
                      MAP_KEY:item['MAP_KEY']?item['MAP_KEY']:"",
                      obj:item
                    }
                  )
                }       
                    
                boothList.sort(function(a, b) {
                  const nameA = (a.company+" "+a.name).toLowerCase(); // ignore upper and lowercase
                  const nameB = (b.company+" "+a.name).toLowerCase(); // ignore upper and lowercase
                  
                  return `${nameA}`.localeCompare(`${nameB}`)
                });
                setAllBoothList(boothList)
              }
              setLoadingFlag(false)
              setLoaded(true)
          }
          else{
            setLoadingFlag(false)
          }
      }).catch(error => {
        setLoadingFlag(false)
      })  
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    useEffect(() => {
        // getAllBoothList();
        fetchCuratedList();
        return () => {
          for(var i = 0; i < highlightedBooths.length; i++){
            var booth = highlightedBooths[i]
            deselectHighlightObject(booth, props.main);
          }
          props.main.mainCanvas.renderAll();
        };
      }, [props.ui.curatedId]);      
      
      useEffect(() => {
        // if(props.main.boothLoaded)
          getAllBoothList();
        //  fetchCuratedList();
      }, [props.main.boothLoaded])
    

    return (
        <Fade in={true} timeout={1200}>
            <div className='appLeftSearch'>
                <Divider/>
                {loaded &&
                    <Exhibitors boothList={allBoothList} role={props.role} curated={1} open={loaded}/>
                }
            
            <LoadingOverlay
            active={loadingFlag}
            styles={{
                overlay: (base) => ({
                ...base,
                fontSize:'18px',
                color: 'rgb(5, 37, 51)',
                background: 'transparent',
                position:'absolute',
                left:'50%',
                top:'200px',
                transform:'translateX(-50%)',
                zIndex:1000000000
                })
            }}
            spinner = {<ScaleLoader color={props.ui?.customStyles?.['spinner-color']?props.ui?.customStyles['spinner-color']:'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
            // spinner
            // text='Loading ...'
            >
        </LoadingOverlay> 
        </div>
        </Fade>
    );
}


const mapStateToProps = (state) => {
  return {
    main: state.main,
    ui: state.ui,
    booth_history: state.booth_history.present
  };
};

const mapDispatchProps = (dispatch) => {
  return { 
    setLeftPage: value=>dispatch(setLeftPage(value)) ,
    setOpenLogin: value=>dispatch(setOpenLogin(value)) ,
    setLeftBoothList:  data=>dispatch(setLeftBoothList(data)),
    setOpenBoothList: value=>dispatch(setOpenBoothList(value)) ,
    setActive3dObject: value=>dispatch(setActive3dObject(value)) ,
    setExhibitorList:  data=>dispatch(setExhibitorList(data)),
    setSearchOptions:  data=>dispatch(setSearchOptions(data)),
    setCuratedId: data=>dispatch(setCuratedId(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);

